import { Button, Select, Space } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Option } from "../../../common/forms/Interfaces";
import { IFilterProps } from "./Interfaces";

interface Props extends IFilterProps {
  options?: Option[];
  multiple?: boolean;
}

const SELECT_WIDTH = 220;

const SelectFilter: React.FC<Props> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  options,
  selectedKeys,
  multiple,
}) => {
  const [value, setValue] = useState<string | string[] | undefined>(
    multiple ? [] : ""
  );

  useEffect(() => {
    if (!Array.isArray(selectedKeys)) {
      return;
    }

    if (selectedKeys.length === 0) {
      return;
    }

    if (multiple) {
      setValue(selectedKeys as string[]);
      return;
    }

    const defaultValue = [...selectedKeys].shift();

    if (defaultValue !== undefined) {
      setValue(defaultValue as string);
    }
  }, [multiple, options, selectedKeys]);

  const resetInputValue = useCallback(() => {
    setValue(multiple ? [] : "");

    if (clearFilters) {
      clearFilters();
    }
  }, [clearFilters, multiple]);

  const antOptions = () =>
    options?.map((option) => (
      <Select.Option key={option.value} value={option.value}>
        {option.title}
      </Select.Option>
    ));

  const onChangeHandler = useCallback(
    (optionValue: string | string[]) => {
      setSelectedKeys(
        Array.isArray(optionValue) ? [...optionValue] : [optionValue]
      );
      setValue(optionValue);
      confirm();
    },
    [confirm, setSelectedKeys]
  );

  const onFilterOptionHandler = useCallback((input, option) => {
    if (!option) {
      return false;
    }

    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }, []);

  return (
    <div className="table-filter">
      <Space direction="horizontal">
        <Select<string | string[]>
          style={{ width: SELECT_WIDTH }}
          onChange={onChangeHandler}
          value={value}
          className="table-select"
          size="small"
          showSearch
          mode={multiple ? "multiple" : undefined}
          filterOption={onFilterOptionHandler}
        >
          {antOptions()}
        </Select>
        <Button
          size="small"
          type="text"
          disabled={!value}
          onClick={resetInputValue}
          className="button-group__button"
        >
          <CloseOutlined />
        </Button>
      </Space>
    </div>
  );
};

export default SelectFilter;
